import { Checkbox as AntCheckbox } from 'antd';

import { Tooltip } from 'components/common';
import { useMemo } from 'react';

const Checkbox = ({ helpText, labelText, onChange, labelStyle, ...rest }) => {
  const handleChange = e => {
    onChange && onChange(e.target.checked);
  };

  // Checkbox does not allow 'allowClear' in the DOM
  const filteredProps = useMemo(() => {
    const fp = { ...rest };
    if (fp.hasOwnProperty('allowClear')) {
      delete fp['allowClear'];
    }
    return fp;
  }, [rest]);

  return (
    <AntCheckbox
      {...filteredProps}
      style={{ marginLeft: '0px', ...rest.style }}
      onChange={handleChange}
    >
      <Tooltip title={helpText} placement='right'>
        <span style={labelStyle}>{labelText}</span>
      </Tooltip>
    </AntCheckbox>
  );
};

Checkbox.defaultProps = {
  'data-testid': 'checkbox',
};

export default Checkbox;
